/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';

import {
  ROOMS_PUBLISHING_STATE_DONE,
  ROOMS_PUBLISHING_STATE_ERROR,
  ROOMS_PUBLISHING_STATE_FETCHING,
  RoomsPublishingActions
} from 'store/action/rooms-publishing';
import {IPortalError} from 'utility/error-handler';

export interface IRoomsPublishingState {
  publishingState: {roomId: string; isOnline: boolean; multipleStreams: boolean}[];
  isFetching: boolean;
  error: null | IPortalError;
}

const initialRoomsPublishingState: IRoomsPublishingState = {
  isFetching: false,
  publishingState: [],
  error: null
};

export const roomsPublishingReducer: Reducer<
  Readonly<IRoomsPublishingState>,
  RoomsPublishingActions
> = (
  state: IRoomsPublishingState = initialRoomsPublishingState,
  action: RoomsPublishingActions
) => {
  switch (action.type) {
    case ROOMS_PUBLISHING_STATE_FETCHING: {
      return {
        ...state,
        isFetching: true,
        error: null
      };
    }

    case ROOMS_PUBLISHING_STATE_DONE: {
      return {
        ...state,
        isFetching: false,
        publishingState: action.payload
      };
    }

    case ROOMS_PUBLISHING_STATE_ERROR: {
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    }

    default:
      return state;
  }
};

export default roomsPublishingReducer;